import useUser from '../contexts/hooks/useUser'
import { trpc } from '../modules/trpc'

export const useAuthorizations = () => {
	const { isCustomer } = useUser()

	const { data, isFetching, refetch } = trpc.user.supplyAgreements.useQuery(undefined, {
		enabled: !isCustomer,
		staleTime: 2 * 60 * 1000, // 2 minutes
		refetchOnWindowFocus: true, // Refetch when the window regains focus, AKA when user returns from Datahub after authorizing
	})
	return { data, isFetching, refetch }
}
